'use strict';

module.exports = function getNumberOfAtoms() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var label = options.atomLabel;
  var mf = this.getMolecularFormula().formula;
  var parts = mf.split(/(?=[A-Z])/);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var part = _step.value;

      var atom = part.replace(/[0-9]/g, '');
      if (atom === label) {
        return part.replace(/[^0-9]/g, '') * 1 || 1;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return 0;
};